import layout from '@/views/common/layout'
const goodsRouter = [
    // {
    //     path: '/goods',
    //     component: layout,
    //     children: [
    //         {
    //             path: 'goodsList',
    //             component: () => import('@/views/goods/goodsList'),
    //             name: 'goodsList',
    //             meta: { title: '商品列表', icon: '', affix: true }
    //         },
    //         {
    //             path: 'editGoods',
    //             component: () => import('@/views/goods/editGoods'),
    //             name: 'editGoods',
    //             meta: { title: '编辑商品', icon: '', affix: true }
    //         },
    //         {
    //             path: 'editGoodsDetailRouter',
    //             component: () => import('@/views/goods/editGoodsDetailRouter'),
    //             name: 'editGoodsDetail',
    //             meta: { title: '编辑商品详情', icon: '', affix: true }
    //         },
    //     ]
    // },
    {
        path: '/category',
        component: layout,
        children: [
            {
                path: 'editCategory',
                component: () => import('@/views/goods/editCategory'),
                name: 'editCategory',
                meta: { title: '编辑分类', icon: '', affix: true }
            },
            {
                path: 'editAttr',
                component: () => import('@/views/goods/categoryAttrList'),
                name: 'editAttr',
                meta: { title: '分类属性', icon: '', affix: true }
            },
            {
                path: 'editIntegralCategory',
                component: () => import('@/views/goods/editIntegralCategory'),
                name: 'editIntegralCategory',
                meta: { title: '编辑分类', icon: '', affix: true }
            },
            {
                path: 'integralCategoryAttrList',
                component: () => import('@/views/goods/integralCategoryAttrList'),
                name: 'integralCategoryAttrList',
                meta: { title: '分类维护', icon: '', affix: true }
            },

        ]
    },
    // {
    //     path: '/goodsName',
    //     component: layout,
    //     children: [
    //         {
    //             path: 'goodsNameList',
    //             component: () => import('@/views/goods/goodsNameList'),
    //             name: 'goodsNameList',
    //             meta: { title: '商品名称列表', icon: '', affix: true }
    //         }
    //     ]
    // },
    // {
    //     path: '/goodsStock',
    //     component: layout,
    //     children: [
    //         {
    //             path: 'stockList',
    //             component: () => import('@/views/stock/goodsStockList'),
    //             name: 'goodsStockList',
    //             meta: { title: '库存列表', icon: '', affix: true }
    //         },
    //         {
    //             path: 'stockDetail',
    //             component: () => import('@/views/stock/stockDetail'),
    //             name: 'goodsStockList',
    //             meta: { title: '库存详情', icon: '', affix: true }
    //         },
    //         {
    //             path: 'stockBalanceList',
    //             component: () => import('@/views/stock/stockBalanceList'),
    //             name: 'stockBalanceList',
    //             meta: { title: '库存出入库明细列表', icon: '', affix: true }
    //         }
    //     ]
    // },
    // {
    //     path: '/goodsPicture',
    //     component: layout,
    //     children: [
    //         {
    //             path: 'editGoodsPicture',
    //             component: () => import('@/views/goods/editGoodsPicture'),
    //             name: 'editGoodsPicture',
    //             meta: { title: '商品图片', icon: '', affix: true }
    //         }
    //     ]
    // },
    // {
    //     path: '/goodsDetailRule',
    //     component: layout,
    //     children: [
    //         {
    //             path: 'list',
    //             component: () => import('@/views/goods/goodsDetailRuleList'),
    //             name: 'goodsDetailRuleList',
    //             meta: { title: '商品详情规则', icon: '', affix: true }
    //         },
    //         {
    //             path: 'editDetailRule',
    //             component: () => import('@/views/goods/editGoodsDetailRule'),
    //             name: 'editGoodsDetailRule',
    //             meta: { title: '编辑商品详情规则', icon: '', affix: true }
    //         }
    //     ]
    // },
    //  {
    //     path: '/sampleGoods',
    //     component: layout,
    //     children: [
    //         {
    //             path: 'sampleGoodsList',
    //             component: () => import('@/views/goods/sampleGoodsList'),
    //             name: 'sampleGoodsList',
    //             meta: { title: '样品集合', icon: '', affix: true }
    //         },
    //         {
    //             path: 'editSampleGoods',
    //             component: () => import('@/views/goods/editSampleGoodsRule'),
    //             name: 'editSampleGoods',
    //             meta: { title: '编辑商品详情规则', icon: '', affix: true }
    //         }
    //     ]
    // },
    // {
    //     path: '/inventory',
    //     component: layout,
    //     children: [
    //         {
    //             path: 'needInventoryGoods',
    //             component: () => import('@/views/stock/needInventoryGoods'),
    //             name: 'needInventoryGoods',
    //             meta: { title: '需要盘点商品列表', icon: '', affix: true }
    //         },
    //         {
    //             path: 'inventoryList',
    //             component: () => import('@/views/inventory/inventoryList'),
    //             name: 'inventoryList',
    //             meta: { title: '盘点单列表', icon: '', affix: true }
    //         }
    //     ]
    // },
    // {
    //     path: '/goodsPrice',
    //     component: layout,
    //     children: [
    //         {
    //             path: 'getGoodsPrices',
    //             component: () => import('@/views/goodsPrice/goodsPriceList'),
    //             name: 'getGoodsPrices',
    //             meta: { title: '商品价格列表', icon: '', affix: true }
    //         }
    //     ]
    // }
]

export default goodsRouter



// WEBPACK FOOTER //
// ./src/router/modules/goodsRouter.js